function LogoutIcon({ className }) {
  return (
    <svg className={`ic ${className}`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.9999 4C15.2666 4 14.6666 4.6 14.6666 5.33333V16C14.6666 16.7333 15.2666 17.3333 15.9999 17.3333C16.7332 17.3333 17.3332 16.7333 17.3332 16V5.33333C17.3332 4.6 16.7332 4 15.9999 4ZM22.8532 7.81333C22.3332 8.33333 22.3466 9.14667 22.8399 9.66667C24.3466 11.2667 25.2799 13.4 25.3332 15.76C25.4532 20.8667 21.2266 25.2667 16.1199 25.32C10.9066 25.4 6.66657 21.2 6.66657 16C6.66657 13.5467 7.61324 11.32 9.15991 9.65333C9.65324 9.13333 9.65324 8.32 9.14657 7.81333C8.61324 7.28 7.74657 7.29333 7.23991 7.84C5.30657 9.89333 4.09324 12.6267 3.99991 15.6533C3.81324 22.16 9.10657 27.7867 15.6132 27.9867C22.4132 28.2 27.9999 22.7467 27.9999 15.9867C27.9999 12.8267 26.7732 9.97333 24.7732 7.84C24.2666 7.29333 23.3866 7.28 22.8532 7.81333Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default LogoutIcon;
